import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
import { shimmerAnimation, getShimmerStyles, getColors } from './shared';
const useStyles = createUseStyles(theme => {
  const {
    baseColor,
    shimmerColor
  } = getColors(theme);
  return {
    root: {
      position: 'relative'
    },
    shimmer: { ...getShimmerStyles(theme, {
        opacity: 0,
        backgroundColor: shimmerColor,
        animation: '$shimmer 2s infinite',
        borderRadius: theme.SHAPE.CIRCULAR
      })
    },
    chart: ({
      size
    }) => ({
      position: 'relative',
      height: `${size}px`,
      width: `${size}px`,
      backgroundColor: baseColor,
      borderRadius: theme.SHAPE.CIRCULAR
    }),
    inner: ({
      size
    }) => ({
      position: 'absolute',
      top: 0,
      left: 0,
      height: `${size * 0.8}px`,
      width: `${size * 0.8}px`,
      margin: `${size * 0.1}px`,
      borderRadius: theme.SHAPE.CIRCULAR,
      backgroundColor: 'white'
    }),
    angle: ({
      size
    }) => ({
      position: 'absolute',
      top: 0,
      left: 0,
      height: 0,
      width: 0,
      border: `${size / 2}px solid transparent`,
      borderBottom: `${size / 2}px solid white`
    }),
    ...shimmerAnimation
  };
});
export const SkeletonPieChart = props => {
  const {
    type = 'default',
    classes: classesProp,
    className: classNameProp,
    size,
    ...rest
  } = props;
  const classes = useStyles(classesProp, {
    size
  });
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.chart, classes.shimmer)
  }), type !== 'default' && /*#__PURE__*/React.createElement("div", {
    className: classes.inner
  }), type === 'journey' && /*#__PURE__*/React.createElement("div", {
    className: classes.angle
  }));
};